import { AxiosResponse } from 'axios'
import { queryOptions } from '@tanstack/react-query'
import { createUrl } from './helpers'
import axiosAuth from './config'
import { NBoardroomContacts } from '../interfaces/services/boardroom-contacts.interfaces'

export const getContactsPerSociety = (
  societyId: string
): Promise<AxiosResponse<NBoardroomContacts.NGetPerSocieties.IResponse>> => {
  return axiosAuth.get<NBoardroomContacts.NGetPerSocieties.IResponse>(
    createUrl(`/boardroom-contacts/get-per-society/${societyId}`, {})
  )
}

export const getContact = (
  id: string
): Promise<AxiosResponse<NBoardroomContacts.NGetById.IResponse>> => {
  return axiosAuth.get<NBoardroomContacts.NGetById.IResponse>(
    createUrl(`/boardroom-contacts/contact/${id}`, {})
  )
}

export const patchContact = (params: {
  id: string
  body: NBoardroomContacts.NPatch.IRequestBody
}): Promise<AxiosResponse<NBoardroomContacts.NPatch.IResponse>> => {
  return axiosAuth.patch<NBoardroomContacts.NPatch.IResponse>(
    createUrl(`/boardroom-contacts/contact/${params.id}`),
    params.body
  )
}

export const createContact = (
  body: NBoardroomContacts.NCreate.IRequestBody
): Promise<AxiosResponse<NBoardroomContacts.NCreate.IResponse>> => {
  return axiosAuth.post<NBoardroomContacts.NCreate.IResponse>(
    createUrl(`/boardroom-contacts/contact`),
    body
  )
}

export const deleteContact = (
  id: string
): Promise<AxiosResponse<NBoardroomContacts.NDel.IResponse>> => {
  return axiosAuth.delete<NBoardroomContacts.NDel.IResponse>(
    createUrl(`/boardroom-contacts/contact/${id}`)
  )
}

export const boardRoomContactQueries = {
  getContact: (boardRoomContactId?: string) =>
    queryOptions({
      queryKey: [
        { scope: 'societyContact', entity: 'detail', boardRoomContactId },
      ],
      queryFn: async ({ queryKey }) => {
        return (await getContact(queryKey[0].boardRoomContactId!)).data.data
      },
      enabled: !!boardRoomContactId,
    }),
  getContactsPerSociety: (societyId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'societyContact', entity: 'society', societyId }],
      queryFn: async ({ queryKey }) => {
        return (await getContactsPerSociety(queryKey[0].societyId!)).data.data
      },
      enabled: !!societyId,
    }),
}
